import React from "react";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box, Paper, Typography } from "@material-ui/core";
import { AttachFile, Link as LinkIcon, CloudUpload } from "@material-ui/icons";
import { i18n } from "../../translate/i18n";
import PromptMediaPreview from "../PromptMediaPreview";

// D8.3.5a — Sección "Archivos multimedia" (presentacional; sin acople a Formik).
export default function PromptMediaSection({
    classes,
    promptId,
    mediaFiles,
    loadingMedia,
    mediaMessage,
    isDragging,
    setUrlModalOpen,
    fileInputRef,
    handleFileUpload,
    handleDeleteMedia,
    handleReorder,
}) {
    return (
        <Paper className={classes.formSection}>
            <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={1}>
                <Typography className={classes.sectionTitle}>
                    <AttachFile style={{ marginRight: 8 }} />
                    {i18n.t("promptModal.sections.media")}
                </Typography>
                <Box display="flex" gap={1}>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<LinkIcon />}
                        onClick={() => {
                            if (!promptId) {
                                toast.error(i18n.t("promptModal.media.savePromptFirstToast"));
                                return;
                            }
                            setUrlModalOpen(true);
                        }}
                        disabled={loadingMedia || mediaFiles.length >= 6}
                    >
                        {i18n.t("promptModal.media.addUrl")}
                    </Button>
                    <input
                        ref={fileInputRef}
                        type="file"
                        multiple
                        accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                        style={{ display: "none" }}
                        onChange={(e) => {
                            const files = e.target.files;
                            console.log("🔵 [onChange] Archivos seleccionados:", files?.length);

                            if (files && files.length > 0) {
                                // ✅ Convertir FileList a Array ANTES de pasar a la función
                                const filesArray = Array.from(files);
                                console.log("✅ [onChange] Archivos convertidos:", filesArray.length);

                                // ✅ Limpiar el input DESPUÉS de procesar (no antes)
                                e.target.value = "";

                                // ✅ Llamar a la función con el array
                                handleFileUpload(filesArray);
                            } else {
                                console.warn("⚠️ [onChange] No se seleccionaron archivos");
                            }
                        }}
                    />
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<CloudUpload />}
                        onClick={() => {
                            if (!promptId) {
                                toast.error(i18n.t("promptModal.media.savePromptFirstToast"));
                                return;
                            }
                            fileInputRef.current?.click();
                        }}
                        disabled={loadingMedia || mediaFiles.length >= 6}
                    >
                        {i18n.t("promptModal.media.uploadFile")}
                    </Button>
                </Box>
            </Box>

            {/* ✅ Mensaje informativo/error en el modal (no toast) */}
            {mediaMessage.text && (
                <Box
                    style={{
                        marginBottom: 16,
                        padding: 12,
                        borderRadius: 4,
                        backgroundColor: mediaMessage.type === 'error' ? '#ffebee' : '#e8f5e9',
                        border: `1px solid ${mediaMessage.type === 'error' ? '#f44336' : '#4caf50'}`,
                        color: mediaMessage.type === 'error' ? '#c62828' : '#2e7d32'
                    }}
                >
                    <Typography style={{ fontSize: "13px", fontWeight: 500 }}>
                        {mediaMessage.type === 'error' ? '❌' : '✅'} {mediaMessage.text}
                    </Typography>
                </Box>
            )}

            <Box className={classes.infoBox} style={{ marginBottom: 16 }}>
                <Typography className={classes.infoText} style={{ fontSize: "12px" }}>
                    {i18n.t("promptModal.media.hintFiles")}
                </Typography>
                <Typography className={classes.infoText} style={{ fontSize: "12px" }}>
                    {i18n.t("promptModal.media.hintLimits")}
                </Typography>
                <Typography className={classes.infoText} style={{ fontSize: "12px" }}>
                    {i18n.t("promptModal.media.hintSyntax")}
                </Typography>
            </Box>

            {loadingMedia ? (
                <Box display="flex" justifyContent="center" padding={3}>
                    <CircularProgress size={24} />
                </Box>
            ) : (
                <PromptMediaPreview
                    mediaFiles={mediaFiles}
                    onDelete={handleDeleteMedia}
                    onReorder={handleReorder}
                    isDragging={isDragging}
                />
            )}

            {mediaFiles.length > 0 && (
                <Box marginTop={1}>
                    <Typography variant="caption" color="textSecondary">
                        {i18n.t("promptModal.media.filesCount", { current: mediaFiles.length })}
                    </Typography>
                </Box>
            )}
        </Paper>
    );
}
